import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

// `confirmedReceiptAt` is optional because the open attempt (from
// markAppeasementSent) has no date yet — the date is supplied later by
// confirmAppeasementPayment when the operator confirms receipt.
export const ConfirmAppeasementPaymentTaskAttemptSchema = z.object({
  type: z.literal(TaskType.CONFIRM_APPEASEMENT_PAYMENT),
  appeasementId: z.string().min(1),
  confirmedReceiptAt: z.iso.datetime().optional(),
});
